// src/composables/useValidation.js
import { VerificationCodeValidation, EmailValidation, NameValidation } from '@/utils/validation';

export function useValidation() {
  // Name
  const sanitizeName = (name) => NameValidation.sanitize(name);
  const validateName = (name) => NameValidation.isValid(name);
  const processName = (name) => NameValidation.process(name);

  // Email
  const sanitizeEmail = (email) => EmailValidation.sanitize(email);
  const validateEmail = (email) => EmailValidation.isValid(email);
  const processEmail = (email) => EmailValidation.process(email);

  // Verification Code
  const sanitizeVerificationCode = (code) => VerificationCodeValidation.sanitize(code);
  const validateVerificationCode = (code) => VerificationCodeValidation.isValid(code);
  const processVerificationCode = (code) => VerificationCodeValidation.process(code);

  return {
    sanitizeName,
    validateName,
    processName,
    sanitizeEmail,
    validateEmail,
    processEmail,
    sanitizeVerificationCode,
    validateVerificationCode,
    processVerificationCode
  };
}
